import { useState } from 'react'
import { SvgIcon, RouteLink } from '@/components'
import { StyledFooter, StyledContainer } from '@/components/styles'
import { useInfo } from '@/contexts/InfoContext'

export default function ({ footerStyle }) {
    const { categories, social } = useInfo()
    const [telIsOpen, setTelIsOpen] = useState(false)
    const [dropdownIsOpen, setDropdownIsOpen] = useState(null)
    const year = new Date().getFullYear();
    const toTopFunc = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    return (
        <StyledFooter darkBack={footerStyle === 'dark'}>
            <StyledFooter.Top darkBack={footerStyle === 'dark'}>
                <StyledContainer>
                    <StyledFooter.Inner>
                        <StyledFooter.Social dark={footerStyle === 'dark'}>
                            {social.map((item) => (
                                <StyledFooter.SocialItem
                                    key={item.id}
                                    href={item.value}
                                    target="_blank"
                                    dark={footerStyle === 'dark'}
                                >
                                    <SvgIcon
                                        name={
                                            footerStyle === 'dark' && item.type != 'tik_tok' && item.type != 'yandex_zen'
                                                ? `${item.type}-white`
                                                : item.type
                                        }
                                        width={item.type == 'tik_tok' || item.type == 'yandex_zen' ? 36 : 16}
                                        height={item.type == 'tik_tok' || item.type == 'yandex_zen' ? 36 : 16}
                                    />
                                </StyledFooter.SocialItem>
                            ))}
                        </StyledFooter.Social>
                        <StyledFooter.Contacts white={footerStyle === 'dark'}>
                            <StyledFooter.Phone href="tel:+375291433229">+375 (29) 143-32-29</StyledFooter.Phone>
                        </StyledFooter.Contacts>
                    </StyledFooter.Inner>
                </StyledContainer>
            </StyledFooter.Top>
            <StyledFooter.Nav>
                <StyledContainer>
                    <StyledFooter.NavInner>
                        {categories.footer.map((column, idx) => (
                            <StyledFooter.NavColumn key={idx}>
                                {column.map((navItem) => (
                                    <StyledFooter.NavItem
                                        key={navItem.id}
                                        dark={footerStyle === 'dark'}
                                    >
                                        <StyledFooter.NavTitle
                                            white={footerStyle === 'dark'}
                                            mb={navItem.children?.length > 0}
                                            arrow={navItem.children?.length > 0}
                                            isOpen={dropdownIsOpen === navItem.id}
                                            onClick={() =>
                                                setDropdownIsOpen(
                                                    dropdownIsOpen === navItem.id
                                                        ? null
                                                        : navItem.id,
                                                )
                                            }
                                        >
                                            <RouteLink slug={navItem.slug}>
                                                <a>{navItem.name}</a>
                                            </RouteLink>
                                        </StyledFooter.NavTitle>
                                        {navItem.children?.length > 0 && (
                                            <StyledFooter.NavSubmenu
                                                isOpen={dropdownIsOpen === navItem.id}
                                            >
                                                {navItem?.children.map((item) => (
                                                    <StyledFooter.NavSubmenuItem key={item.id}>
                                                        <RouteLink slug={item.slug}>
                                                            <a>{item.name}</a>
                                                        </RouteLink>
                                                    </StyledFooter.NavSubmenuItem>
                                                ))}
                                            </StyledFooter.NavSubmenu>
                                        )}
                                    </StyledFooter.NavItem>
                                ))}
                            </StyledFooter.NavColumn>
                        ))}
                    </StyledFooter.NavInner>
                </StyledContainer>
            </StyledFooter.Nav>
            <StyledFooter.Bottom dark={footerStyle === 'dark'} large={footerStyle === 'large'}>
                <StyledContainer>
                    <StyledFooter.Inner>
                        <StyledFooter.Copyright>
                            Владелец сайта: Ювилс Лизинг, УНП 192825384
                            <br />
                            © 2019-{year} | Все права защищены.
                            <br />
                            <a href="/documents">Документы</a>
                        </StyledFooter.Copyright>
                        <StyledFooter.Copyright>
                            ООО «Ювилс Лизинг» не является финансовой или микрофинансовой организацией, не оказывает услуг по оформлению и предоставлению населению микрозаймов, кредитов и других финансовых услуг, регулируемых Указом Президента №394 "О привлечении и предоставлении займов, деятельности микрофинансовых организаций" от 30.06.2014г.
                        </StyledFooter.Copyright>
						<StyledFooter.BottomText>
							<p>ООО «Ювилс Лизинг» не осуществляет возмездное оказание консультационных и (или) информационных услуг об условиях предоставления кредитов, займов, условиях лизинга физическим лицам (за исключением индивидуальных предпринимателей).</p>
							<SvgIcon name="logo-small" width="48" height="48" />
						</StyledFooter.BottomText>
                        <StyledFooter.Dev
                            href="/"
                            target="_blank"
                        >
                        </StyledFooter.Dev>
                    </StyledFooter.Inner>
                </StyledContainer>
            </StyledFooter.Bottom>
            <StyledFooter.Arrow onClick={toTopFunc}>
                <SvgIcon name="arrow-top" width="23" height="15" />
            </StyledFooter.Arrow>
        </StyledFooter>
    )
}
